export default "__VITE_ASSET__CURxem11__"